var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-body" }, [
      _c("div", {
        staticClass: "modal-body--alert alert alert-danger d-none",
        attrs: { role: "alert" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row h-100 w-100" },
        [
          _c(
            "div",
            { staticClass: "modal-body--preview col-6" },
            [
              _vm.artboards.length > 1
                ? _c("PSDArtboardsPreview", {
                    attrs: {
                      "image-src": _vm._f("share")(_vm.entireImageThumbnail),
                      artboards: _vm.artboards,
                      "source-size": {
                        width: _vm.parsedPsdModel.width,
                        height: _vm.parsedPsdModel.height,
                      },
                    },
                    on: {
                      "artboard-click": _vm.handlePreviewImageArtboardClick,
                    },
                  })
                : _c("div", [
                    !_vm.previewTemplateThumbnail
                      ? _c("img", {
                          staticClass: "modal-body--preview__img",
                          class: { "d-none": _vm.isImageLoading },
                          attrs: {
                            src: _vm._f("share")(_vm.entireImageThumbnail),
                            alt: "preview",
                          },
                          on: { load: _vm.imageLoadedHandler },
                        })
                      : _c("img", {
                          staticClass: "modal-body--preview__img",
                          attrs: {
                            src: _vm.previewTemplateThumbnail,
                            alt: "preview",
                          },
                        }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "spinner-border modal-body--preview__spinner",
                        class: { "d-none": !_vm.isImageLoading },
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.previewTemplateThumbnail
                      ? _c(
                          "div",
                          {
                            staticClass: "modal-body--preview__img-close",
                            on: {
                              click: function ($event) {
                                return _vm.setPreviewTemplateThumbnail({
                                  previewTemplateThumbnail: "",
                                })
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              { attrs: { width: "20px", height: "20px" } },
                              [
                                _c("use", {
                                  attrs: {
                                    href: "/img/icons/sprite.svg#file-circle-close",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("LayersTree", {
            staticClass: "modal-body--layers-wrapper col-6",
            attrs: { templates: _vm.templates },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "col d-flex justify-content-end align-items-start",
          staticStyle: { gap: "0.25rem" },
        },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-1",
              attrs: { disabled: _vm.isSavingNodesChanges },
              on: { click: _vm.cancel },
            },
            [_vm._v("\n        Close\n      ")]
          ),
          _vm._v(" "),
          _vm.isNodesChangesShouldBeSaved
            ? _c(
                "b-button",
                {
                  staticClass: "d-flex align-items-center",
                  attrs: { disabled: _vm.isSavingNodesChanges },
                  on: { click: _vm.saveNodesChanges },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.isSavingNodesChanges
                            ? "Saving changes..."
                            : "Save changes"
                        ) +
                        "\n          "
                    ),
                    _vm.isSavingNodesChanges
                      ? _c("i", {
                          staticClass: "spinner-border spinner-border-sm m-0",
                        })
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _vm.isTemplateFeatures && _vm.isImportIntoTemplate
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.isUpdatingPreviewTemplate,
                    },
                    on: { click: _vm.updatePreviewTemplate },
                  },
                  [
                    _c("span", {
                      staticClass: "spinner-border spinner-border-sm",
                      class: { "d-none": !_vm.isUpdatingPreviewTemplate },
                      attrs: { role: "status", "aria-hidden": "true" },
                    }),
                    _vm._v("\n          Preview\n        "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isTemplateFeatures
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.isAddToTemplateButtonAvailable,
                    },
                    on: { click: _vm.addToTemplate },
                  },
                  [
                    _c("span", {
                      staticClass: "spinner-border spinner-border-sm",
                      class: { "d-none": _vm.isAddToTemplateButtonAvailable },
                      attrs: { role: "status", "aria-hidden": "true" },
                    }),
                    _vm._v("\n          Add to template\n        "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.availableDefaultFlow
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.isExtractingAssets || _vm.isSavingNodesChanges,
                    },
                    on: { click: _vm.proceedByFlow },
                  },
                  [
                    _c("span", {
                      staticClass: "spinner-border spinner-border-sm",
                      class: { "d-none": !_vm.isExtractingAssets },
                      attrs: { role: "status", "aria-hidden": "true" },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.proceedButtonLabel) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isTemplateFeatures
      ? _c("div", { staticClass: "position-relative" }, [
          _c(
            "div",
            { staticClass: "template-features-buttons" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: { click: _vm.iccProfileOpen },
                },
                [_vm._v("\n        Adjust ICC\n      ")]
              ),
              _vm._v(" "),
              _vm.isProductRecognitionAvailable
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.isProductRecognitionProcessing,
                      },
                      on: { click: _vm.requestProductRecognition },
                    },
                    [_vm._v("\n        Recognize product images\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isTemplateFeatures && _vm.isImportIntoTemplate
      ? _c("div", { staticClass: "row mt-2 mb-2" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "autoMapToFields",
                    checked: _vm.isAutoMapToFields,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setAutoMapFields()
                    },
                  },
                },
                [_vm._v("\n        Auto map to fields\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  attrs: {
                    title:
                      "Checking this option will remove any default text from the destination templates",
                    checked: _vm.isRemovePlaceholderText,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setRemovePlaceholderText({
                        isRemovePlaceholderText: !_vm.isRemovePlaceholderText,
                      })
                    },
                  },
                },
                [_vm._v("\n        Remove placeholder text\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { checked: _vm.isUseSourceTextSettings },
                  on: {
                    change: function ($event) {
                      return _vm.setUseSourceTextSettings({
                        isUseSourceTextSettings: !_vm.isUseSourceTextSettings,
                      })
                    },
                  },
                },
                [_vm._v("\n        Use source text settings\n      ")]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2 psd-import-options" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _vm.isOpenBannerInBuilderAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "isOpenInBannerBuilder",
                    checked: _vm.isOpenInBannerBuilder,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setIsOpenInBannerBuilder(
                        !_vm.isOpenInBannerBuilder
                      )
                    },
                  },
                },
                [_vm._v("\n        Open in Banner Builder\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUseProductImagesFromPSDAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "isUseProductImagesFromPSD",
                    checked: _vm.isUseProductImagesFromPSD,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setIsUseProductImagesFromPSD({
                        value: !_vm.isUseProductImagesFromPSD,
                      })
                    },
                  },
                },
                [_vm._v("\n        Use product images from PSD\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isReplaceExistingProductAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "replaceExistingProduct",
                    checked: _vm.isReplaceExistingProduct,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setReplaceExistingProduct({
                        isReplaceExistingProduct: !_vm.isReplaceExistingProduct,
                      })
                    },
                  },
                },
                [_vm._v("\n        Replace existing product images\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSavePsdAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: { id: "savePsd", checked: _vm.isSavePsd },
                  on: {
                    change: function ($event) {
                      return _vm.setSavePsd({ value: !_vm.isSavePsd })
                    },
                  },
                },
                [_vm._v("\n        Save PSD\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isImportWithoutLayersAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "addWithoutLayers",
                    checked: _vm.isImportWithoutLayers,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setIsImportWithoutLayers({
                        isImportWithoutLayers: !_vm.isImportWithoutLayers,
                      })
                    },
                  },
                },
                [_vm._v("\n        Add without layers\n      ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _vm.isTreatMultipleSpacesAsSingleAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "isTreatMultipleSpacesLineBreak",
                    checked: _vm.isTreatMultipleSpacesAsSingle,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setTreatMultipleSpacesAsSingle({
                        isTreatMultipleSpacesAsSingle:
                          !_vm.isTreatMultipleSpacesAsSingle,
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        Treat multiple spaces as single space\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPhotoshopTextGeometryAvailable
            ? _c(
                "b-form-checkbox",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  attrs: {
                    id: "textGeometryMode",
                    title:
                      "Preserves Photoshop paragraph box dimensions during this import.",
                    checked: _vm.textGeometryMode === "photoshop",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setTextGeometryMode({
                        textGeometryMode:
                          _vm.textGeometryMode === "photoshop"
                            ? "legacy"
                            : "photoshop",
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        Preserve Photoshop text geometry (Beta)\n      "
                  ),
                ]
              )
            : _vm.isTemplateFeatures
            ? _c("small", { staticClass: "d-block text-muted" }, [
                _vm._v(
                  "\n        Reparse PSD to enable beta text geometry.\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isGroupGroupedLayersAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "isGroupGroupedLayers",
                    checked: _vm.isGroupGroupedLayers,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setIsGroupGroupedLayers({
                        isGroupGroupedLayers: !_vm.isGroupGroupedLayers,
                      })
                    },
                  },
                },
                [_vm._v("\n        Group grouped layers\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isResizeAllowedAvailable
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "isResizeAllowed",
                    checked: _vm.isResizeAllowed,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setIsResizeAllowed({
                        isResizeAllowed: !_vm.isResizeAllowed,
                      })
                    },
                  },
                },
                [_vm._v("\n        Resize if larger than 5000x5000 px\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSaveImagesToTheme
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "createIndividualAssets",
                    checked: _vm.isCreateIndividualAssets,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setCreateIndividualAssets({
                        isCreateIndividualAssets: !_vm.isCreateIndividualAssets,
                      })
                    },
                  },
                },
                [_vm._v("\n        Create individual assets\n      ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }